var render, staticRenderFns
import script from "./chat-text-message.vue?vue&type=script&lang=js"
export * from "./chat-text-message.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c8ad809')) {
      api.createRecord('4c8ad809', component.options)
    } else {
      api.reload('4c8ad809', component.options)
    }
    
  }
}
component.options.__file = "resources/assets/js/components/chat/messages/chat-text-message.vue"
export default component.exports